<template>
    <div class="flex items-center mt-10 px-5">
          <!-- BOX -->
            <div class="md:w-3/4 mx-auto bg-white md:p-5 lg:p-10 rounded-md shadow-xl">
            <!-- FORM -->
              <form id="form" @submit.prevent="register">
              <!-- FORM & ISLAND  -->
              <div class="flex md:flex-row lg:flex-row flex-col m-7 py-5">
                <transition name="form-content">
                <div v-if="show" class="min-w-100 lg:w-1/2 w-full">
                  <div class="mb-6">
                      <label for="name" class="block mb-2 text-sm font-bold text-gray-600 text-left">Full Name</label>
                      <input
                      v-model="user.name"
                      type="text" name="name" id="name" placeholder="e.g: John Doe" required class="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                  </div>
                  <div class="mb-6">
                      <label for="email" class="block mb-2 text-sm font-bold text-gray-600 text-left">Email Address</label>
                      <input
                      v-model="user.email"
                      type="email" name="email" id="email" placeholder="e.g: you@mail.com" required class="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                  </div>
                  <div class="mb-6">
                      <label for="password" class="block mb-2 text-sm font-bold  text-gray-600 text-left">Password</label>
                      <input
                      v-model="user.password"
                      type="password" name="password" id="password" placeholder="min 6 character" required class="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                  </div>
                  <div class="mb-6">
                      <label for="password" class="block mb-2 text-sm font-bold  text-gray-600 text-left">Confirm Password</label>
                      <input
                      v-model="user.confirmPassword"
                      type="password" name="password" id="password" placeholder="min 6 character" required class="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                  </div>
                  <div class="mb-6">
                      <label for="phone" class="block text-sm font-bold text-gray-600 text-left">Phone Number</label>
                      <div class="flex">
                        <div class="">
                          <h1 class="font-bold px-3 py-2 placeholder-gray-300 border border-gray-300 bg-gray-200 rounded-l-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500">+62</h1>
                        </div>
                        <input
                        v-model="user.phone"
                        type="text" name="phone" id="phone" placeholder="8xx-xxxx-xxxx" required class="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-r-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                      </div>
                  </div>
                  <div class="flex flex-col text-gray-500 mb-6">
                    <div class="flex flex-row">
                      <input
                      v-model="user.status"
                      class="inline mr-2 mt-1"
                      type="radio" id="non-nasabah" value="Non Nasabah">
                      <label class="text-left inline" for="non-nasabah">Non Nasabah</label>
                    </div>
                    <div class="flex flex-row">
                      <input
                      v-model="user.status"
                      class="inline mr-2 mt-1"
                      type="radio" id="nasabah" value="Nasabah">
                      <label class="text-left inline" for="nasabah">Nasabah</label>
                    </div>
                  </div>
                  <div
                  v-if="user.status === 'Nasabah'"
                  class="mb-6">
                    <label for="bankAccount" class="block mb-2 text-sm font-bold text-gray-600 text-left">Bank Account</label>
                      <input
                      v-model="user.bankAccount"
                      type="text" name="bankAccount" id="bankAccount" placeholder="e.g: 60432" required class="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                  </div>
                </div>
                </transition>
                  <div class="flex justify-center items-center w-full">
                <transition name="island-content">
                    <img v-if="show"
                    class="my-5 px-5 lg:ml-10 md:ml-10 "
                    src="../assets/virtualIsland.png" alt="Virtual Island">
                </transition>
                  </div>
                </div>
                <!-- FORM & ISLAND  -->
                <transition name="button-content">
                  <div v-if="show" class="mb-6 w-40 mx-auto">
                      <button type="submit" class="w-full px-3 py-2 text-white text-lg font-medium bg-red-700 rounded-3xl focus:bg-red-800 focus:outline-none focus:shadow-none shadow-2xl">Submit</button>
                  </div>
                </transition>
              </form>
              <!-- END OF FORM -->
            </div>
         <!-- END OF BOX -->
    </div>
</template>

<script>
export default {
  name: 'Form',
  data () {
    return {
      user: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
        status: '',
        bankAccount: ''
      },
      show: false
    }
  },
  mounted () {
    this.show = !this.show
  },
  methods: {
    register () {
      if (this.user.password === this.user.confirmPassword) {
        this.$store.dispatch('registerUser', this.user)
      } else {
        console.log('password not match')
      }
    },
    leavePage () {
      this.show = !this.show
      setTimeout(() => this.$router.push({ path: '/register' }), 1000)
    }
  }
}
</script>

<style>
/* island */
  .form-content-enter-active {
    transition: all 1s ease;
    transition-delay: .4s;
  }
  .form-content-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .form-content-enter
  /* .form-content-leave-active below version 2.1.8 */ {
    transform: translateY(-50px);
    opacity: 0;
  }
  .form-content-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
  /* content */
  .island-content-enter-active {
    transition: all 1s ease;
    transition-delay: .6s;
  }
  .island-content-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .island-content-enter, .island-content-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
  /* Button */
  .button-content-enter-active {
    transition: all 1s ease;
    transition-delay: .2s;
  }
  .button-content-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .button-content-enter, .button-content-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
</style>
